module.exports = __webpack_public_path__ + "img/drag0.191c0cd8.svg";